export const isNumeric = (str: string) => Boolean(str.trim()) && !isNaN(+str.replaceAll(',', '.'))
